import React, { useState, useRef, useContext, useEffect } from "react";
import axios from "axios";
import AuthContext from "../../../../context/userAuth.context";
import MyContext from "../../../../context/MyContext";
import Photocontainer from "./Photocontainer";
import swal from "sweetalert";
import Lottie from "react-lottie";
import loader from "../../../../assets/Loader/AssetLoader.json";

const ImageUploader = (props) => {
  const { ImageData, setImageData } = useContext(MyContext);
  const { authenticationData } = useContext(AuthContext);
  const [MyLoader, setMyLoader] = useState(false);
  const [UploadData, setUploadData] = useState(null);
  const [isDeleted, setIsDeleted] = useState(false);

  const ImageUploderRef = useRef(null);

  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const fileChangeHandle3 = (e) => {
    var formdata = new FormData();

    formdata.append("file", e.target.files[0]);
    props.setDeafultLoader({ played: true, stat: true });
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Images/uploadImage",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        props.setDeafultLoader({ played: false, stat: false });
        if (response.data) {
          let urls = [];
          response.data.map((val, index) => {
            urls.push({
              id: val.id,
              previewURL: authenticationData.ApiBaseURL + val.path,
              fullHDURL: authenticationData.ApiBaseURL + val.path,
              relativePath: val.path,
            });
          });
         
          setImageData({
            apiData: ImageData.apiData,
            UserData: ImageData.UserData.concat(urls),
          });
          setIsDeleted(false);
          swal("Excellent", "Image Has Been Uploaded", "success");
        } else {
          swal("Failed", "Unable to Upload Image. Please Try Again", "error");
        }
      })
      .catch((excetion) => {
        props.setDeafultLoader({ played: false, stat: false });
        console.log(excetion);
        swal("Failed", "Unable to Upload Image. Please Try Again", "error");
      });
  };

  useEffect(() => {
    //if (ImageData.UserData.length === 0) {
      setMyLoader(true);

      fetch(authenticationData.ApiBaseURL + "/api/images/GetMyImgs", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
        .then((response) => response.json())
        .then((success) => {
          setMyLoader(false);
          let urls = [];
          success.map((val, index) => {
            urls.push({
              id: val.id,
              previewURL: authenticationData.ApiBaseURL + val.path,
              fullHDURL: authenticationData.ApiBaseURL + val.path,
              relativePath: val.path,
            });
          });
         
          setImageData({ ...ImageData, UserData: urls });
          //setUploadData(urls);
        })
        .catch((error) => {
          setMyLoader(false);
        });
   // }
    
  }, []);

  

  const imageUpload = () => {
    ImageUploderRef.current.click();
  };

  return (
    <>
      <div className="image_uploader">
        <div onClick={imageUpload} className="image_uploader_inner">
          <div className="image_uploader_icon_container">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 486.3 486.3"
            >
              <g>
                <g>
                  <path
                    fill="#286aff"
                    d="M395.5,135.8c-5.2-30.9-20.5-59.1-43.9-80.5c-26-23.8-59.8-36.9-95-36.9c-27.2,0-53.7,7.8-76.4,22.5
			                                    c-18.9,12.2-34.6,28.7-45.7,48.1c-4.8-0.9-9.8-1.4-14.8-1.4c-42.5,0-77.1,34.6-77.1,77.1c0,5.5,0.6,10.8,1.6,16
			                                    C16.7,200.7,0,232.9,0,267.2c0,27.7,10.3,54.6,29.1,75.9c19.3,21.8,44.8,34.7,72,36.2c0.3,0,0.5,0,0.8,0h86
			                                    c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-85.6C61.4,349.8,27,310.9,27,267.1c0-28.3,15.2-54.7,39.7-69
                                                c5.7-3.3,8.1-10.2,5.9-16.4c-2-5.4-3-11.1-3-17.2c0-27.6,22.5-50.1,50.1-50.1c5.9,0,11.7,1,17.1,3c6.6,2.4,13.9-0.6,16.9-6.9
                                                c18.7-39.7,59.1-65.3,103-65.3c59,0,107.7,44.2,113.3,102.8c0.6,6.1,5.2,11,11.2,12c44.5,7.6,78.1,48.7,78.1,95.6
                                                c0,49.7-39.1,92.9-87.3,96.6h-73.7c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h74.2c0.3,0,0.6,0,1,0c30.5-2.2,59-16.2,80.2-39.6
                                                c21.1-23.2,32.6-53,32.6-84C486.2,199.5,447.9,149.6,395.5,135.8z"
                  />
                  <path
                    fill="#286aff"
                    d="M324.2,280c5.3-5.3,5.3-13.8,0-19.1l-71.5-71.5c-2.5-2.5-6-4-9.5-4s-7,1.4-9.5,4l-71.5,71.5c-5.3,5.3-5.3,13.8,0,19.1
                                                c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l48.5-48.5v222.9c0,7.5,6,13.5,13.5,13.5s13.5-6,13.5-13.5V231.5l48.5,48.5
                                                C310.4,285.3,318.9,285.3,324.2,280z"
                  />
                </g>
                Add Subtitle
              </g>
            </svg>
          </div>

          <div className="Image_uploader_text">
            <div>Upload Image</div>
            <input
              ref={ImageUploderRef}
              type="file"
              hidden
              onChange={fileChangeHandle3}
              accept="image/png, image/jpeg, image/svg+xml"
            />
          </div>
        </div>
      </div>

      {ImageData.UserData !== null && isDeleted == false && (
        <Photocontainer
          isUserImage={"true"}
          Pic={ImageData.UserData}
          type={"Images"}
          setUploadData={setUploadData}
          UploadData={UploadData}
          setIsDeleted={setIsDeleted}
        />
      )}

      {UploadData && (
        <Photocontainer
          isUserImage={"true"}
          Pic={UploadData}
          type={"Images"}
          setUploadData={setUploadData}
          UploadData={UploadData}
          setIsDeleted ={setIsDeleted}
        />
      )}
{/* 
      {UploadData.length > 0 && (
        <Photocontainer
          isUserImage={"true"}
          Pic={ImageData.UserData}
          type={"Images"}
          getMyImages = {getMyImages}
        />
      )} */}

      {MyLoader == true && (
        <Lottie
          options={{ loop: true, autoplay: true, animationData: loader }}
          height={200}
          width={200}
          isStopped={false}
          isPaused={false}
        />
      )}
    </>
  );
};

export default ImageUploader;
